import styled from "styled-components";

export const MusicHallBookingFormStyled = styled.div`
  .input_wrap {
    margin-bottom: 16px;
    .field_hint {
      margin-top: 6px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    }
  }
  .btn_zone {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    column-gap: 10px;
    .w120 {
      width: 120px;
    }
  }
`;
